module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "title",
      rawName: "v-title",
      value: ('找不到数据'),
      expression: "'找不到数据'"
    }],
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/common/none-01.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s5"
  }, [_vm._v("暂无数据")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0e912692"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFound.vue
// module id = 11
// module chunks = 11